import { Link } from '@tanstack/react-router';

interface ErrorBoundaryProps {
  error: Error;
  reset: () => void;
}

export function ErrorBoundary({ error, reset }: ErrorBoundaryProps) {
  return (
    <div className="flex h-svh flex-col items-center justify-center gap-4">
      <div className="text-center">
        <h1 className="text-destructive mb-2 text-2xl font-bold">
          Etwas ist schiefgelaufen
        </h1>
        <p className="text-muted-foreground mb-4">
          Bitte versuchen Sie es erneut.
        </p>

        {import.meta.env.DEV && (
          <details className="mb-4 text-left">
            <summary className="text-muted-foreground cursor-pointer text-sm">
              Fehlerdetails (nur für Entwickler)
            </summary>
            <pre className="text-muted-foreground bg-muted mt-2 overflow-auto rounded p-2 text-xs">
              {error.message}

              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}
      </div>

      <div className="flex gap-2">
        <button
          onClick={reset}
          className="bg-primary text-primary-foreground hover:bg-primary/90 rounded px-4 py-2"
        >
          Erneut versuchen
        </button>
        <Link
          to="/"
          className="border-input bg-background hover:bg-accent hover:text-accent-foreground rounded border px-4 py-2"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
